<style lang="scss">
@import "./assets/style/public";
@import "./assets/style/dfStyle";
@import '~@/assets/style/public-class.scss';
@import "./assets/common/font/font.css";
.operation .el-dialog--center .el-dialog__body{
  padding: 15px 25px;
}
.operation .el-dialog--center .operation_btn .el-form-item__content{
  margin-left: 0 !important;
}
</style>
<template>
  <div id="app">
    <transition name="fade-transform1" mode="out-in">
      <router-view v-if="isRouterAlive" />
    </transition>
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>
<style>
 .topic-outer{
   border-bottom: 1px solid rgba(0,0,0,0.1);
   margin-top: 0 !important;
 }

 .list-style{
   box-shadow: 0 0 10px 1px rgba(0,0,0,0.1);
 }
 /*.topic-outer .appraisal-center{*/
 /*  border-bottom: 0 !important;*/
 /*  margin-top: 30px !important;*/
 /*}*/
 .appraisal-center{

 }
 .tab_info_casertyudsad{
   border-bottom: 1px solid rgba(0,0,0,0.1);
   margin-top: 0 !important;
   margin-bottom: 0 !important;
 }
 .style_info_tab_case{
   padding:20px 10px;
 }
</style>


